import { SearchInput } from "@kanda-libs/ks-component-ts";
import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
  InfoBanner,
} from "@kanda-libs/ks-design-library";
import PageTitle from "components/shared/PageTitle";
import type { FunctionComponent } from "react";
import LeadTable from "../LeadTable";
import useLeadListPage from "./useLeadListPage";

const LeadsListPage: FunctionComponent = function () {
  const { leads, query, setQuery } = useLeadListPage();

  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <PageTitle>Leads</PageTitle>
        <InfoBanner
          title="Leads"
          search={
            <SearchInput
              placeholder="Search leads"
              query={query}
              onSearch={setQuery}
            />
          }
        />
        <LeadTable leads={leads} />
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default LeadsListPage;
